export function primaryNav() {
  const navElements = document.querySelectorAll(".nav-element");

  // --- Underline animation --- //
  const underlineAnimationDuration = 150; // in ms

  navElements.forEach((navElement) => {
    var line = navElement.querySelector(".line");
    var mainLink = navElement.querySelector(".nav-main-link"); // container of the main <a> and the arrow icon

    // Set initial state
    line.style.transform = "translateX(-100%)";
    line.style.transitionDuration = "0s";

    // mouse in
    mainLink.addEventListener("mouseenter", function (e) {
      line.style.transitionDuration = `0.${underlineAnimationDuration}s`;
      line.style.transform = "translateX(0)";
    });

    // mouse out
    mainLink.addEventListener("mouseleave", function (e) {
      line.style.transform = "translateX(100%)";

      setTimeout(function () {
        line.style.transitionDuration = "0s";
        line.style.transform = "translateX(-100%)";
      }, underlineAnimationDuration);
    });
  });

  // --- Open / close subnav --- //
  navElements.forEach((navElement) => {
    var toggleSubnavs = navElement.querySelectorAll(".toggle-subnav");
    toggleSubnavs.forEach((toggleSubnav) => {
      toggleSubnav.addEventListener("click", function (e) {
        e.preventDefault();

        const arrow = navElement.querySelector(".arrow");
        var isOpen = navElement.classList.toggle("open");

        // if opening, close all other subnavs and reset arrows
        if (isOpen) {
          navElements.forEach((othertNavElement) => {
            if (othertNavElement !== navElement) {
              othertNavElement.classList.remove("open");
              var currentArrow = othertNavElement.querySelector(".arrow");
              // if has an arrow, reset rotation
              if (currentArrow) {
                currentArrow.style.transform = "rotate(180deg)";
              }
            }
          });
        }

        // set clicked nav arrow rotation
        arrow.style.transform = isOpen ? "rotate(0deg)" : "rotate(180deg)";
      });
    });
  });
}
